import {
  CreateContactAttemptDto,
  CreateWorkOrderDto,
  UpdateContactCommentDto,
  UpdateWorkOrderStatusDto,
  WorkOrder,
  WorkOrderFilters,
  WorkOrderWithAppointments,
} from "@myapp/contract";
import apiClient from "../../../shared/config/axios";
import { Paginated } from "../../../shared/types/IPaginationResponse";

export const workOrderApi = {
  search: (params: WorkOrderFilters & { page: number }) =>
    apiClient.get<Paginated<WorkOrderWithAppointments>>("/work-orders", { params }),

  getById: (workOrderId: string) =>
    apiClient.get<WorkOrderWithAppointments>(`/work-orders/${workOrderId}`),

  create: (data: CreateWorkOrderDto) =>
    apiClient.post<WorkOrder>("/work-orders", data),

  /** Manager+ only. Sets the status by hand; answers with the work order as `getById` would. */
  updateStatus: (workOrderId: string, dto: UpdateWorkOrderStatusDto) =>
    apiClient.patch<WorkOrderWithAppointments>(`/work-orders/${workOrderId}/status`, dto),

  /** Office only; only while the status is NOT_REACHED. Answers with the work order. */
  addContactAttempt: (workOrderId: string, dto: CreateContactAttemptDto) =>
    apiClient.post<WorkOrderWithAppointments>(`/work-orders/${workOrderId}/contact-attempts`, dto),

  deleteContactAttempt: (workOrderId: string, attemptId: number) =>
    apiClient.delete<WorkOrderWithAppointments>(
      `/work-orders/${workOrderId}/contact-attempts/${attemptId}`,
    ),

  /** An empty string clears the comment. */
  updateContactComment: (workOrderId: string, dto: UpdateContactCommentDto) =>
    apiClient.patch<WorkOrderWithAppointments>(`/work-orders/${workOrderId}/contact-comment`, dto),
};
